import {Typography} from '@mui/material';
import {FilterDrawer} from 'presentation/pages/private/my-hospitalization/components/FilterDrawer';
import React from 'react';
import {translations} from 'presentation/translations-new';
import {StyledContainer} from './styles';
import {HeaderFilterExamsProps} from './types';

const {resultFound, resultsFound} = translations['pt-br'].commons;

export const HeaderFilterExams = ({
	count = 0,
	listDrawerItens,
	titleListDrawer,
}: HeaderFilterExamsProps) => (
	<StyledContainer>
		<Typography color={'text.secondary'} textTransform={'lowercase'}>
			<b>{count}</b> {count === 1 ? resultFound : resultsFound}
		</Typography>
		<FilterDrawer listDrawerItens={listDrawerItens} titleListDrawer={titleListDrawer} />
	</StyledContainer>
);
